export default function addTimeplanUnits(timeplanUnits, originalTPUs, updatedValues) {
  /*
  if (timeplanUnits.find(tpu => tpu.id === originalTPU.id)) {
    return timeplanUnits.map((tpu) => {
      if (tpu.id === originalTPU.id) {
        return originalTPU.merge(updatedValues);
      }
      return tpu;
    });
  }
  */

  return timeplanUnits.push(...originalTPUs);
}
